import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { CollectionPaths } from '@models/collections';
import { MatterWordDocument } from '@models/matter-word-documents';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Repo } from '@repos/repo.service';
import { UserProfileState } from '@state/user-profile';

export interface MatterWordDocumentsPathParams {
	matterId: string;
}

@Injectable({
	providedIn: 'root',
})
export class MatterWordDocumentsRepo extends Repo<
	MatterWordDocument,
	MatterWordDocumentsPathParams
> {
	@SelectSnapshot(UserProfileState.getCurrentBusinessId) businessId;

	constructor(private firestore: AngularFirestore) {
		super(firestore);
	}

	GetCollectionPath(pathParams: MatterWordDocumentsPathParams): string {
		return CollectionPaths.business_matter_matterWordDocuments(
			this.businessId,
			pathParams.matterId,
		);
	}
}
